import { createFileRoute } from '@tanstack/react-router'

import { OrderFeedbackPage } from '#/modules/activity/feedback-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/order-feedback')({
  component: OrderFeedbackPage,
  validateSearch: validateListSearch,
})
